import { jsx } from 'react/jsx-runtime';
import { useState, useCallback } from 'react';
import '../icons/ActivityIcon.js';
import '../icons/ArrowDownIcon.js';
import '../icons/ArrowDownRightCircleIcon.js';
import '../icons/ArrowLeftAlignIcon.js';
import '../icons/ArrowLeftIcon.js';
import '../icons/ArrowRightAlignIcon.js';
import '../icons/ArrowRightIcon.js';
import '../icons/ArrowSwitchIcon.js';
import '../icons/ArrowUpIcon.js';
import '../icons/ArrowUpRightCircleIcon.js';
import '../icons/ArrowsAngleExpandIcon.js';
import '../icons/BankIcon.js';
import 'lodash';
import 'styled-components';
import CheckIcon from '../icons/CheckIcon.js';
import '../icons/ChevronDownIcon.js';
import '../icons/ChevronRightIcon.js';
import '../icons/ChevronUpIcon.js';
import CopyIcon from '../icons/CopyIcon.js';
import '../icons/CrossIcon.js';
import '../icons/DaiIcon.js';
import '../icons/DangerIcon.js';
import '../icons/DownSortIcon.js';
import '../icons/ExclamationTriangleIcon.js';
import '../icons/ExpandKpiIcon.js';
import '../icons/EyeIcon.js';
import '../icons/EyeSlashIcon.js';
import '../icons/Grid1x2Icon.js';
import '../icons/InfoCircleIcon.js';
import '../icons/ListIcon.js';
import '../icons/LockIcon.js';
import '../icons/MediumIcon.js';
import '../icons/MoonIcon.js';
import '../icons/PiggyBankIcon.js';
import '../icons/QuestionMarkCircleIcon.js';
import '../icons/ShieldIcon.js';
import '../icons/SunIcon.js';
import '../icons/UpSortIcon.js';
import '../icons/XIcon.js';
import '../icons/InfinityIcon.js';
import '../icons/ArrowUpRightBoxIcon.js';
import '../../theme/GlobalStyle.js';
import 'react-helmet-async';
import ThemedComponentWrapper from '../../theme/ThemedComponentWrapper.js';

function CopyButton({ value, size, ...rest }) {
    const [copied, setCopied] = useState(false);
    const handleCopyClick = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (navigator.clipboard) {
            navigator.clipboard.writeText(value).then(() => {
                setCopied(true);
                setTimeout(() => {
                    setCopied(false);
                }, 10000);
            });
        }
    }, [value]);
    return (jsx(ThemedComponentWrapper, { onClick: handleCopyClick, ...rest, name: "copyButton", children: copied ? jsx(CheckIcon, { size: size }) : jsx(CopyIcon, { size: size }) }));
}

export { CopyButton as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
